module.exports = __webpack_public_path__ + "img/8.123017ae.jpg";